<template>
 <section class="users-page">
  <header-page :title="$route.meta.title" />
  <app-actions
   v-if="allowed && $route.name === 'users'"
   class="users-resource-actions"
   resource-uri="users"
   @run-action="runUserAction"
  />
  <div class="users-content">
  <v-card class="users-card" flat>
   <v-card-title class="users-heading">
    <div class="users-title-group"><span class="users-title-icon"><v-icon aria-hidden="true">people_outline</v-icon></span><div><span class="users-eyebrow">ADMINISTRACIÓN</span><h1>{{ $route.meta.title }}</h1></div></div><v-spacer />
    <v-btn v-if="$route.name !== 'users'" outline class="users-back-action" color="secondary" :to="{ name: 'users' }" :disabled="saving"><v-icon small left aria-hidden="true">arrow_back</v-icon>Volver a usuarios</v-btn>
   </v-card-title>
   <v-card-text>
    <v-alert :value="!!error" type="error">{{ error }}</v-alert>
    <v-alert :value="!!message" type="success">{{ message }}</v-alert>
    <v-progress-linear v-if="loading" indeterminate />
    <template v-if="allowed && !loading && ready">
     <template v-if="$route.name === 'users'">
      <p>Administra los auxiliares y las empresas cliente con las que pueden trabajar.</p>
      <app-table
       :key="$route.name" class="users-table" :class="{ 'users-table--companies': $route.name === 'users-companies' }" :name="$route.name"
       :columns="tableColumns" :rows="pagedRows" :key-value="$route.name === 'users-link' ? 'codeUser' : 'id'"
       :current-page="currentPage" :last-page="lastPage"
       :items-quantity="pagedRows.length" :items-total-quantity="filteredRows.length"
       @on-search-event="search = $event" @on-page="changePage"
      >
       <template slot="rows" slot-scope="props">
        <td v-show="tableColumns[0].visible" class="is-not-selectable user-name-cell"><div class="user-identity"><span class="user-avatar" aria-hidden="true">{{ (props.row.userName || '?').trim().slice(0, 1).toUpperCase() }}</span><strong>{{ props.row.userName }}</strong></div></td><td v-show="tableColumns[1].visible">{{ props.row.email }}</td>
        <td v-show="tableColumns[2].visible"><span class="user-role" :class="{ 'user-role--admin': props.row.flagAccountant }"><v-icon small aria-hidden="true">{{ props.row.flagAccountant ? 'verified_user' : 'person_outline' }}</v-icon>{{ props.row.flagAccountant ? 'Contador administrador' : 'Auxiliar' }}</span></td>
        <td v-if="props.row.flagAccountant" v-show="tableColumns[3].visible"><span class="user-access"><v-icon small aria-hidden="true">business</v-icon>Todas las empresas</span></td>
        <td v-else v-show="tableColumns[3].visible" class="celda-empresas">
         <span v-if="Number(props.row.assignedCustomers) > 0" class="user-access">
          <v-icon small aria-hidden="true">business</v-icon>
          {{ props.row.assignedCustomers }} {{ Number(props.row.assignedCustomers) === 1 ? 'empresa' : 'empresas' }}
         </span>
         <span v-else class="sin-empresas user-access"><v-icon small aria-hidden="true">info_outline</v-icon>Sin empresas</span>
         <v-tooltip top>
          <v-btn slot="activator" icon class="users-icon-action" :aria-label="'Asignar empresas a ' + props.row.userName" :to="{ name: 'users-companies', params: { id: props.row.id } }">
           <v-icon small aria-hidden="true">business</v-icon>
          </v-btn>
          <span>{{ Number(props.row.assignedCustomers) > 0 ? 'Cambiar empresas asignadas' : 'Asignar empresas' }}</span>
         </v-tooltip>
        </td>
        <td v-show="tableColumns[4].visible" class="user-state-cell">
         <span class="user-state" :class="{ 'user-state--off': Number(props.row.status) === 0 }">
          <v-icon small aria-hidden="true">{{ Number(props.row.status) === 0 ? 'block' : 'check_circle' }}</v-icon>
          {{ Number(props.row.status) === 0 ? 'Desactivado' : 'Activo' }}
         </span>
        </td>
        <td v-show="tableColumns[5].visible">
					<v-tooltip top>
							<v-btn slot="activator" icon class="users-icon-action"
						:aria-label="'Permisos de ' + props.row.userName"
						:to="{ name: 'user-permissions', params: { id: props.row.id } }">
						<v-icon small aria-hidden="true">tune</v-icon>
						</v-btn>
						<span>Permisos del usuario</span>
					</v-tooltip>
					<v-tooltip top>
						<v-btn slot="activator" icon class="users-icon-action" :aria-label="'Editar usuario ' + props.row.userName" :to="{ name: 'users-edit', params: { id: props.row.id } }">
						<v-icon small aria-hidden="true">edit</v-icon>
						</v-btn>
						<span>Editar usuario</span>
					</v-tooltip>
         <v-tooltip top>
          <v-btn slot="activator" icon class="users-icon-action" :class="{ 'users-icon-action--danger': Number(props.row.status) !== 0 }" :disabled="saving" :aria-label="(Number(props.row.status) === 0 ? 'Activar a ' : 'Desactivar a ') + props.row.userName" @click="toggleStatus(props.row)">
           <v-icon small aria-hidden="true">{{ Number(props.row.status) === 0 ? 'lock_open' : 'block' }}</v-icon>
          </v-btn>
          <span>{{ Number(props.row.status) === 0 ? 'Permitir el ingreso' : 'Bloquear el ingreso' }}</span>
         </v-tooltip>
        </td>
       </template>
      </app-table>
     </template>
     <template v-else-if="$route.name === 'users-link'">
      <p>Usuarios que ya existen en ACL para esta organización. Al vincularlos quedan como auxiliares y luego les asignas empresas.</p>
      <app-table
       :key="$route.name" class="users-table" :class="{ 'users-table--companies': $route.name === 'users-companies' }" :name="$route.name"
       :columns="tableColumns" :rows="pagedRows" :key-value="$route.name === 'users-link' ? 'codeUser' : 'id'"
       :current-page="currentPage" :last-page="lastPage"
       :items-quantity="pagedRows.length" :items-total-quantity="filteredRows.length"
       @on-search-event="search = $event" @on-page="changePage"
      >
       <template slot="rows" slot-scope="props">
        <td v-show="tableColumns[0].visible" class="is-not-selectable">{{ props.row.name }}</td><td v-show="tableColumns[1].visible">{{ props.row.email }}</td><td v-show="tableColumns[2].visible">{{ props.row.codeUser }}</td>
        <td v-show="tableColumns[3].visible">
         <span v-if="props.row.linkedElsewhere">Vinculado en otra organización</span>
         <span v-else-if="props.row.linked">Ya vinculado</span>
         <v-tooltip v-else top>
          <v-btn slot="activator" icon class="users-icon-action" :aria-label="'Vincular a ' + props.row.name" :loading="saving" :disabled="saving" @click="linkUser(props.row)">
           <v-icon small aria-hidden="true">link</v-icon>
          </v-btn>
          <span>Vincular usuario de ACL</span>
         </v-tooltip>
        </td>
       </template>
      </app-table>
     </template>
     <v-form v-else-if="$route.name === 'users-new'" ref="form" @submit.prevent="createUser">
      <p class="users-intro">Completa los datos del auxiliar y después asigna las empresas a las que tendrá acceso.</p>
      <form-sidebar class="users-form"><div class="users-fields">
      <base-input :height="40" :hide-details="false" v-model="form.userName" label="Nombre *" required :rules="[required]" :disabled="saving" />
      <base-input :height="40" :hide-details="false" v-model="documentNumber" inputmode="numeric" pattern="[0-9]*" label="Número de documento" :rules="[required, documentRule]" @keydown.space.native.prevent @input.native="cleanDocumentInput" :disabled="saving" />
      <div class="users-email-field">
      <base-input :height="40" :hide-details="false" v-model="emailName" label="Nombre del correo" suffix="@quipuconta.com" placeholder="nombre.apellido" autocomplete="off" :rules="[required, emailNameRule]" :disabled="saving" />
       <v-tooltip top>
        <v-btn slot="activator" type="button" icon class="users-email-generator" :disabled="saving || !suggestedEmailName" aria-label="Generar correo con el nombre y número de documento" @click="generateEmail">
         <v-icon aria-hidden="true">help_outline</v-icon>
        </v-btn>
        <span>{{ suggestedEmailName ? 'Generar correo con nombre y documento' : 'Completa el nombre y número de documento' }}</span>
       </v-tooltip>
      </div>
      <base-input :height="40" :hide-details="false" v-model="form.phone" label="Teléfono (opcional)" :disabled="saving" />
      <base-input :height="40" :hide-details="false" v-model="form.password" label="Contraseña" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" :rules="[required]" :disabled="saving">
       <v-btn slot="append" type="button" icon class="users-password-toggle" :disabled="saving" :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'" :aria-pressed="showPassword" @click="showPassword = !showPassword">
        <v-icon small aria-hidden="true">{{ showPassword ? 'visibility_off' : 'visibility' }}</v-icon>
       </v-btn>
      </base-input>
      <base-select :hide-details="false" v-model="form.roleId" :items="roles" item-text="name" item-value="id" label="Rol" :rules="[required]" :disabled="saving" />
      </div><div class="users-commercial">
      <v-checkbox v-model="form.createInCommercial" :disabled="saving" hide-details label="Crear también en el sistema comercial" />
      <p class="nota-comercial">Sin marcar, el usuario solo entra a Contabilidad. Al marcarla se crea además su empleado en la empresa comercial de esta organización, y requiere que tú tengas empleado comercial.</p>
      </div></form-sidebar>
      <p v-if="!roles.length">No hay roles disponibles para esta organización. Revisa su configuración en ACL.</p>
      <div class="users-create-actions">
       <v-btn type="submit" class="users-primary-action users-save-action" :loading="saving" :disabled="saving || !roles.length"><v-icon small left aria-hidden="true">person_add</v-icon>Crear y continuar a empresas</v-btn>
      </div>
     </v-form>
     <v-form v-else-if="$route.name === 'users-edit'" ref="form" @submit.prevent="updateUser">
      <p class="users-intro">Actualiza los datos de {{ target.userName }}.</p>
      <form-sidebar class="users-form"><div class="users-fields">
      <base-input :height="40" :hide-details="false" v-model="form.userName" label="Nombre *" required :rules="[required]" :disabled="saving" />
      <base-input :height="40" :hide-details="false" v-model="documentNumber" inputmode="numeric" pattern="[0-9]*" label="Número de documento" :rules="[required, documentRule]" @keydown.space.native.prevent @input.native="cleanDocumentInput" :disabled="saving" />
      <base-input :height="40" :hide-details="false" v-model="form.phone" label="Teléfono (opcional)" :disabled="saving" />
      <base-input :height="40" :hide-details="false" v-model="form.email" label="Correo" :disabled="true" />
      <base-input :height="40" :hide-details="false" v-model="form.password" label="Nueva contraseña (opcional)" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" :disabled="saving">
       <v-btn slot="append" type="button" icon class="users-password-toggle" :disabled="saving" :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'" :aria-pressed="showPassword" @click="showPassword = !showPassword">
        <v-icon small aria-hidden="true">{{ showPassword ? 'visibility_off' : 'visibility' }}</v-icon>
       </v-btn>
      </base-input>
      </div></form-sidebar>
      <p class="nota-comercial">El correo es la credencial de acceso y no se puede cambiar: ACL no expone un servicio para modificarlo. La contraseña sí se actualiza en ACL; déjala vacía para no tocarla.</p>
      <div class="users-create-actions">
       <v-btn type="submit" class="users-primary-action users-save-action" :loading="saving" :disabled="saving"><v-icon small left aria-hidden="true">save</v-icon>Guardar cambios</v-btn>
      </div>
     </v-form>
     <template v-else>
      <h2 class="title">{{ target.userName }}</h2>
      <p>Selecciona las empresas cliente permitidas. Sin asignaciones, el auxiliar no podrá acceder.</p>
      <app-table
       :key="$route.name" class="users-table" :class="{ 'users-table--companies': $route.name === 'users-companies' }" :name="$route.name"
       :columns="tableColumns" :rows="pagedRows" :key-value="$route.name === 'users-link' ? 'codeUser' : 'id'"
       :current-page="currentPage" :last-page="lastPage"
       :items-quantity="pagedRows.length" :items-total-quantity="filteredRows.length"
       @on-search-event="search = $event" @on-page="changePage"
      >
       <template slot="rows" slot-scope="props">
        <td v-show="tableColumns[0].visible" class="is-not-selectable"><v-checkbox v-model="selected" :value="props.row.id" :disabled="saving" hide-details :aria-label="'Permitir acceso a ' + props.row.name" /></td>
        <td v-show="tableColumns[1].visible">{{ props.row.name }}</td><td v-show="tableColumns[2].visible">{{ props.row.ruc || props.row.documentNumber }}</td>
       </template>
      </app-table>
      <div class="users-assignment-actions">
       <div class="users-selection" role="status" aria-live="polite">
        <span class="users-selection-icon"><v-icon aria-hidden="true">business</v-icon></span>
        <div><strong>{{ selected.length }} {{ selected.length === 1 ? 'empresa seleccionada' : 'empresas seleccionadas' }}</strong><span>Guarda para aplicar los permisos de acceso.</span></div>
       </div>
       <v-btn class="users-primary-action users-save-action" :loading="saving" :disabled="saving" @click="saveCompanies"><v-icon small left aria-hidden="true">save</v-icon>Guardar asignaciones</v-btn>
      </div>
     </template>
    </template>
    <v-btn v-if="!loading && !ready" flat @click="load">Reintentar</v-btn>
   </v-card-text>
  </v-card>
  <v-dialog content-class="users-status-dialog" v-model="confirmStatus" :persistent="saving" max-width="460">
   <v-card class="users-status-card" :class="{ 'users-status-card--activate': statusTarget && Number(statusTarget.status) === 0 }" role="alertdialog" aria-modal="true" aria-labelledby="users-status-title" aria-describedby="users-status-description" :aria-busy="saving">
    <div class="users-status-body">
     <span class="users-status-symbol"><v-icon aria-hidden="true">{{ statusTarget && Number(statusTarget.status) === 0 ? 'lock_open' : 'block' }}</v-icon></span>
     <h2 id="users-status-title">{{ statusTarget && Number(statusTarget.status) === 0 ? 'Activar usuario' : 'Desactivar usuario' }}</h2>
     <p id="users-status-description">{{ dialogMessage }}</p>
     <div v-if="statusTarget" class="users-status-identity">
      <span class="users-status-avatar" aria-hidden="true">{{ (statusTarget.userName || '?').trim().slice(0, 1).toUpperCase() }}</span>
      <div><strong>{{ statusTarget.userName }}</strong><span>{{ statusTarget.email }}</span></div>
     </div>
    </div>
    <v-card-actions class="users-status-actions">
     <v-btn flat class="users-status-cancel" :disabled="saving" @click="confirmStatus = false">Cancelar</v-btn>
     <v-btn depressed class="users-status-confirm" :loading="saving" :disabled="saving" @click="applyStatus">{{ statusTarget && Number(statusTarget.status) === 0 ? 'Activar usuario' : 'Desactivar usuario' }}</v-btn>
    </v-card-actions>
   </v-card>
  </v-dialog>
  </div>
 </section>
</template>

<script>
import AppActions from '@/components/shared/app-actions/app-actions';
import BaseInput from '@/components/shared/inputs/base-input';
import BaseSelect from '@/components/shared/inputs/base-select';

function columns(labels) {
	return labels.map((name, index) => ({
		id: index + 1, name, visible: true, checked: true, movil: true,
	}));
}

function rows(data) {
	if (Array.isArray(data)) return data;
	return data.data || data.results || [];
}

export default {
	name: 'page-users',
	components: { AppActions, BaseInput, BaseSelect },
	data() {
		return {
			allowed: false,
			loading: false,
			saving: false,
			showPassword: false,
			ready: false,
			error: '',
			message: '',
			search: '',
			currentPage: 1,
			users: [],
			aclUsers: [],
			companies: [],
			roles: [],
			selected: [],
			target: {},
			confirmStatus: false,
			statusTarget: null,
			form: { userName: '', numberDocument: '', email: '', phone: '', password: '', roleId: null, createInCommercial: false },
			userColumns: columns(['Nombre', 'Correo', 'Tipo', 'Empresas', 'Estado', 'Acciones']),
			companyColumns: columns(['Acceso', 'Empresa', 'Documento']),
			aclColumns: columns(['Nombre', 'Correo', 'Código', 'Acción']),
		};
	},
	created() { this.load(); },
	computed: {
		documentNumber: {
			get() { return this.form.numberDocument; },
			set(value) { this.form.numberDocument = String(value || '').replace(/[^0-9]/g, ''); },
		},
		suggestedEmailName() {
			const name = String(this.form.userName || '').normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '').toLowerCase()
				.replace(/[^a-z0-9]+/g, '.')
				.replace(/^\.+|\.+$/g, '');
			const number = String(this.form.numberDocument || '').replace(/\D/g, '');
			if (!name || !number) return '';
			const parts = name.split('.');
			const first = parts[0].slice(0, 4);
			const last = parts.length > 1 ? `.${parts[parts.length - 1].slice(0, 4)}` : '';
			return `${first}${last}${number.slice(-4)}`;
		},
		emailName: {
			get() { return (this.form.email || '').split('@')[0]; },
			set(value) {
				const name = String(value || '').trim().split('@')[0];
				this.form.email = name ? `${name}@quipuconta.com` : '';
			},
		},
		tableColumns() {
			if (this.$route.name === 'users') return this.userColumns;
			return this.$route.name === 'users-link' ? this.aclColumns : this.companyColumns;
		},
		filteredRows() {
			let items = this.companies;
			let fields = ['name', 'ruc', 'documentNumber'];
			if (this.$route.name === 'users') {
				items = this.users;
				fields = ['userName', 'email'];
			} else if (this.$route.name === 'users-link') {
				items = this.aclUsers;
				fields = ['name', 'email', 'codeUser'];
			}
			const query = String(this.search || '').trim().toLocaleLowerCase();
			return items.filter(item => fields.some(field =>
				String(item[field] || '').toLocaleLowerCase().includes(query)));
		},
		dialogMessage() {
			const user = this.statusTarget;
			if (!user) return '';
			return Number(user.status) === 0
				? 'El usuario podrá volver a iniciar sesión en el sistema.'
				: 'El usuario no podrá iniciar sesión. Puedes volver a activarlo cuando lo necesites.';
		},
		lastPage() { return Math.max(1, Math.ceil(this.filteredRows.length / 10)); },
		pagedRows() {
			return this.filteredRows.slice((this.currentPage - 1) * 10, this.currentPage * 10);
		},
	},
	watch: {
		'$route.fullPath': 'load',
		search() { this.currentPage = 1; },
	},
	methods: {
		cleanDocumentInput(event) {
			const input = event.target;
			const value = input.value.replace(/[^0-9]/g, '');
			input.value = value;
			this.form.numberDocument = value;
		},
		documentRule(value) {
			return /^[0-9]+$/.test(value) || 'El número de documento solo puede contener números.';
		},
		generateEmail() {
			if (!this.saving && this.suggestedEmailName) this.emailName = this.suggestedEmailName;
		},
		runUserAction(action) {
			if (!this.allowed || this.saving || action.disabled) return;
			if (action.codeWeb === 'new-auxiliary') {
				this.$router.push({ name: 'users-new' });
			} else if (action.codeWeb === 'link-with-acl') {
				this.$router.push({ name: 'users-link' });
			}
		},
		changePage(value) {
			const page = Number(value);
			if (Number.isInteger(page) && page >= 1 && page <= this.lastPage) this.currentPage = page;
		},
		required(value) { return !!String(value == null ? '' : value).trim() || 'Campo obligatorio'; },
		emailNameRule(value) {
			return (/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+$/.test(value) &&
				value.length <= 64 && !value.startsWith('.') && !value.endsWith('.') &&
				!value.includes('..')) || 'Ingresa un nombre de correo válido, sin espacios.';
		},
		report(error) {
			const response = error.response || error;
			this.error = (response.data && response.data.message) || 'No se pudo completar la operación. Intenta nuevamente.';
		},
		async load() {
			this.showPassword = false;
			this.loading = true; this.ready = false; this.allowed = false;
			this.error = ''; this.message = ''; this.search = ''; this.selected = [];
			this.currentPage = 1;
			try {
				const { data: session } = await this.$http.get('company-token');
				this.allowed = !!(session.auxiliary &&
						[true, 1].includes(session.auxiliary.flagAccountant));
				if (!this.allowed) {
					this.error = session.accountingSetupRequired
						? 'Falta vincular tu usuario contable. Revisa el rol ACCOUNTANT, la empresa y el proyecto ACL.'
						: 'Solo el contador administrador puede gestionar usuarios.';
					return;
				}
				if (this.$route.name === 'users') {
					const { data } = await this.$http.get('auxiliary'); this.users = rows(data);
				} else if (this.$route.name === 'users-link') {
					const { data } = await this.$http.get('auxiliary-acl-users');
					this.aclUsers = rows(data);
				} else if (this.$route.name === 'users-new') {
					this.form = { userName: '', numberDocument: '', email: '', phone: '', password: '', roleId: null, createInCommercial: false };
					const codeCompany = session.companyAcl && session.companyAcl.code_company;
					if (!codeCompany) {
						this.error = 'No se pudo determinar la organización de la sesión.';
						return;
					}
					const { data } = await this.$httpAcl.get(`company/${codeCompany}/role`);
					this.roles = rows(data);
					if (!this.roles.length) {
						this.error = 'No hay roles disponibles para esta organización. Revísalos en ACL.';
						return;
					}
				} else if (this.$route.name === 'users-edit') {
					const id = Number(this.$route.params.id);
					if (!Number.isInteger(id) || id < 1) { this.error = 'Usuario inválido.'; return; }
					const { data: target } = await this.$http.get(`auxiliary-details/${id}`);
					if (!target || !target.id) { this.error = 'Usuario no encontrado.'; return; }
					this.target = target;
					this.form = {
						userName: target.userName || '',
						numberDocument: target.numberDocument || '',
						email: target.email || '',
						phone: target.phone || '',
						password: '',
						roleId: null,
						createInCommercial: false,
					};
				} else {
					const id = Number(this.$route.params.id);
					if (!Number.isInteger(id) || id < 1) { this.error = 'Usuario inválido.'; return; }
					const { data: target } = await this.$http.get(`auxiliary-details/${id}`);
					if (!target || !target.id || target.flagAccountant) { this.error = 'Selecciona un auxiliar para asignar empresas.'; return; }
					this.target = target;
					const { data } = await this.$http.get(`auxiliary/${id}/customers`);
					this.companies = rows(data);
					this.selected = this.companies
						.filter(item => item.statusAuxiliary === 1).map(item => item.id);
				}
				this.ready = true;
			} catch (error) { this.report(error); } finally { this.loading = false; }
		},
		async createUser() {
			if (this.saving || !this.$refs.form.validate()) return;
			this.saving = true; this.error = '';
			try {
				const { data } = await this.$http.post('auxiliary', this.form);
				this.form.password = '';
				this.$router.push({ name: 'users-companies', params: { id: data.id } });
			} catch (error) { this.report(error); } finally { this.saving = false; }
		},
		async updateUser() {
			if (this.saving || !this.$refs.form.validate()) return;
			this.saving = true; this.error = ''; this.message = '';
			try {
				const payload = {
					userName: this.form.userName,
					numberDocument: this.form.numberDocument,
					phone: this.form.phone,
					email: this.form.email,
				};
				if (this.form.password) payload.password = this.form.password;
				await this.$http.patch(`auxiliary/${this.target.id}`, payload);
				this.$router.push({ name: 'users' });
			} catch (error) { this.report(error); } finally { this.saving = false; }
		},
		toggleStatus(user) {
			if (this.saving) return;
			this.statusTarget = user;
			this.confirmStatus = true;
		},
		async applyStatus() {
			const user = this.statusTarget;
			if (this.saving || !user) return;
			const activar = Number(user.status) === 0;
			this.saving = true; this.error = ''; this.message = '';
			try {
				await this.$http.patch(`auxiliary/${user.id}/status`, { status: activar ? 1 : 0 });
				this.message = activar
					? `${user.userName} puede volver a ingresar.`
					: `${user.userName} ya no puede ingresar al sistema.`;
				this.confirmStatus = false;
				this.statusTarget = null;
				await this.load();
			} catch (error) { this.report(error); } finally { this.saving = false; }
		},
		async linkUser(user) {
			if (this.saving) return;
			this.saving = true; this.error = ''; this.message = '';
			try {
				const { data } = await this.$http.post('auxiliary-link', { codeUser: user.codeUser });
				this.$router.push({ name: 'users-companies', params: { id: data.id } });
			} catch (error) { this.report(error); } finally { this.saving = false; }
		},
		async saveCompanies() {
			if (this.saving) return;
			this.saving = true; this.error = ''; this.message = '';
			try {
				await this.$http.post(`auxiliary/${this.target.id}/customers`, { ids: this.selected });
				this.message = 'Asignaciones guardadas correctamente.';
			} catch (error) { this.report(error); } finally { this.saving = false; }
		},
	},
};
</script>

<style lang="scss">
.users-page {
 background: color(background-table);
 min-height: calc(100vh - 80px);
 color: color(text);
 font-family: font(AvenirRegular);
}
.users-content { max-width: 1240px; padding: 28px; margin: auto; }
.users-card { border: 1px solid color(grey-divider); border-radius: 12px; overflow: hidden; }
.users-heading {
 gap: 12px;
 padding: 24px;
 border-bottom: 1px solid color(grey-divider);
 h1 { background: transparent !important; color: color(black); font-family: font(AvenirBold); font-size: 24px; margin: 4px 0 0; padding: 0; }
}
.users-eyebrow { color: color(secondary); font-size: 11px; letter-spacing: 1.5px; }
.users-card .v-card__text { padding: 24px; }
.users-card .v-btn { border-radius: 6px; text-transform: none; letter-spacing: normal; }
.users-search { max-width: 420px; margin: 20px 0; }
.users-table { overflow-x: auto; margin: 20px 0 0; }
.users-table .table-list { min-width: 880px; }
.users-table td { overflow-wrap: anywhere; }
.users-form { padding: 0; max-width: 900px; }
.users-page .users-create-actions {
 display: flex;
 justify-content: flex-end;
 max-width: 900px;
 margin-top: 16px;
 padding-top: 20px;
 border-top: 1px solid #dce6eb;
}
.users-page .users-create-actions .v-btn__content { white-space: normal; text-align: center; }
.users-page .users-create-actions .users-save-action { height: auto; min-height: 46px; padding-top: 6px; padding-bottom: 6px; }
.users-form .container { padding: 12px 0; }
.users-page .users-email-field { display: flex; align-items: flex-start; gap: 8px; min-width: 0; }
.users-page .users-email-field > .reduce-div { flex: 1; min-width: 0; }
.users-page .users-email-generator { margin: 12px 0 0; width: 36px; height: 36px; border-radius: 10px; background: #e8f5f6 !important; }
.users-page .users-email-generator .v-icon { color: #00858c !important; }
.users-page .users-email-generator.v-btn--disabled { opacity: 0.45; }
.users-page .users-email-generator:focus-visible { outline: 2px solid #00858c; outline-offset: 2px; }
.users-page .users-password-toggle { width: 30px; height: 30px; margin: 0 4px; }
.users-page .users-password-toggle .v-icon { color: #00858c !important; }
.users-page .users-password-toggle:focus-visible { outline: 2px solid #00858c; outline-offset: 2px; }
.users-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px 24px; }
.users-commercial { margin-top: 24px; padding: 8px 16px; background: color(blue-grey); border: 1px solid color(grey-divider); border-radius: 8px; }
.nota-comercial { font-size: 12px; line-height: 1.7; margin: 8px 0; }
.users-page .users-table .user-state-cell { min-width: 148px; white-space: nowrap; }
.users-page .user-state {
 display: inline-flex;
 align-items: center;
 justify-content: center;
 gap: 6px;
 min-height: 28px;
 padding: 4px 10px;
 border: 1px solid #bde4ce;
 border-radius: 999px;
 background: #eaf7ef;
 color: #216e45;
 font-size: 12px;
 font-weight: 600;
 line-height: 18px;
 white-space: nowrap;
 overflow-wrap: normal;
 word-break: normal;
 vertical-align: middle;
}
.users-page .user-state .v-icon { flex: 0 0 16px; font-size: 16px; color: inherit !important; }
.users-page .user-state--off { border-color: #f0c9c5; background: #fff0ee; color: #a33228; }
.users-icon-action--danger { color: color(error); }
.sin-empresas { color: color(error); }
.celda-empresas { white-space: nowrap; }
.users-page .users-table .users-icon-action {
 width: 36px;
 min-width: 36px;
 height: 36px;
 margin: 0 0 0 8px;
 border: 1px solid #c6ddeb;
 border-radius: 10px;
 background: #edf6fc !important;
 color: #006edb !important;
 vertical-align: middle;
}
.users-page .users-table .users-icon-action .v-icon { color: inherit !important; }
.users-page .users-table .users-icon-action:not(.v-btn--disabled):hover { background: #dceefa !important; border-color: #006edb; }
.users-page .users-table .users-icon-action:focus-visible { outline: 2px solid #006edb; outline-offset: 2px; }
.users-page .users-table .users-icon-action.v-btn--disabled { opacity: 0.5; }
.users-page .users-assignment-actions {
 display: flex;
 align-items: center;
 justify-content: space-between;
 gap: 20px;
 margin-top: 24px;
 padding: 20px;
 border: 1px solid #dce6eb;
 border-radius: 10px;
 background: #f8fafc;
}
.users-page .users-selection { display: flex; align-items: center; gap: 12px; margin: 0; }
.users-page .users-selection strong { display: block; color: #2c404a; font-size: 14px; }
.users-page .users-selection > div > span { display: block; margin-top: 4px; color: #607582; font-size: 12px; }
.users-page .users-selection-icon { display: flex; align-items: center; justify-content: center; flex: 0 0 40px; height: 40px; border-radius: 10px; background: #e8f5f6; }
.users-page .users-selection-icon .v-icon { color: #008e95 !important; }
.users-page .users-save-action {
 height: 46px;
 margin: 0;
 padding: 0 22px;
 flex-shrink: 0;
 border: 1px solid rgba(255, 255, 255, 0.18);
 border-radius: 12px;
 background: linear-gradient(135deg, #00888e 0%, #00686f 100%) !important;
 box-shadow: 0 4px 12px rgba(0, 104, 111, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.15);
 font-weight: 600;
 transition: transform 160ms ease, box-shadow 160ms ease;
}
.users-page .users-save-action .v-icon {
 box-sizing: content-box;
 padding: 6px;
 margin-right: 10px;
 border-radius: 8px;
 background: rgba(255, 255, 255, 0.14);
}
.users-page .users-back-action { background: white !important; border-color: #c6d8e7; box-shadow: none; }
.users-page .users-back-action:not(.v-btn--disabled),
.users-page .users-back-action:not(.v-btn--disabled) .v-icon { color: #326282 !important; }
.users-page .users-back-action:not(.v-btn--disabled):hover { background: #f0f6fb !important; border-color: #326282; }
.users-page .users-save-action:not(.v-btn--disabled):hover {
 transform: translateY(-1px);
 box-shadow: 0 6px 16px rgba(0, 104, 111, 0.3);
}
.users-page .users-save-action:not(.v-btn--disabled):active {
 transform: translateY(0);
 box-shadow: 0 2px 6px rgba(0, 104, 111, 0.2);
}
@media (prefers-reduced-motion: reduce) {
 .users-page .users-save-action { transition: none; transform: none !important; }
}
.users-page .users-back-action:focus-visible,
.users-page .users-save-action:focus-visible { outline: 2px solid #006edb; outline-offset: 3px; }
.users-page .users-save-action.v-btn--disabled { opacity: 0.65; }
.users-page .v-input--selection-controls__input .theme--light.v-icon,
.users-page .v-input__append-inner .theme--light.v-icon { color: color(secondary) !important; }

.users-title-group { display: flex; align-items: center; gap: 16px; }
.users-title-icon { display: flex; align-items: center; justify-content: center; width: 48px; height: 48px; border-radius: 14px; background: #e8f5f6; }
.users-page .users-title-icon .v-icon { color: #008e95 !important; font-size: 28px; }
.users-page .users-primary-action, .users-page .users-primary-action .v-icon { color: white !important; }
.users-page .users-heading .v-btn { height: 38px; padding: 0 16px; }
.users-page .users-table .table-list { width: 100%; table-layout: auto; border: 1px solid #dce6eb; border-radius: 10px; }
.users-page .users-table .table-list thead tr.movil-table th { padding: 14px 18px; text-align: left !important; font-size: 12px; font-weight: 600; }
.users-page .users-table .table-list thead tr.movil-table th:nth-child(1) { width: 26%; }
.users-page .users-table .table-list thead tr.movil-table th:nth-child(2) { width: 29%; }
.users-page .users-table .table-list thead tr.movil-table th:nth-child(3) { width: 23%; }
.users-page .users-table .table-list thead tr.movil-table th:nth-child(4) { width: 22%; }
.users-page .users-table .table-list tbody tr td { height: 68px; padding: 14px 18px; text-align: left; border-right: 0; border-top: 1px solid transparent; border-bottom: 1px solid #e8eef2; font-size: 12px; line-height: 1.5; }
.users-page .users-table .table-list tbody tr td:first-child { width: auto; min-width: 220px; padding-left: 18px; }
.users-page .users-table .table-list tbody tr td:nth-child(2) { min-width: 230px; }
.users-page .users-table .table-list tbody tr:hover td { height: 68px !important; background: #edf7f8; font-family: inherit; border-color: transparent !important; }
.users-page .user-identity { display: flex; align-items: center; gap: 12px; }
.users-page .user-identity strong { font-weight: 600; color: #2c404a; overflow-wrap: anywhere; }
.users-page .user-avatar { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 34px; height: 34px; background: #e1f0f4; color: #24758b; border-radius: 50%; font-weight: 700; font-size: 14px; }
.users-page .user-role { display: inline-flex; align-items: center; gap: 6px; padding: 5px 9px; border-radius: 6px; background: #edf1f5; color: #526578; white-space: nowrap; font-size: 11px; }
.users-page .user-role--admin { color: #087c75; background: #e0f3ec; }
.users-page .user-role .v-icon, .users-page .user-access .v-icon { color: inherit !important; }
.users-page .user-access { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; }
.users-page .users-table .table-pagination td { padding: 12px 18px; background: #fff; }
.users-page .users-table .table-pagination .search-input.unique-input { width: 44px; height: 28px; opacity: 1; margin-left: 12px; text-align: center; }
.users-page .users-table .table-pagination .caption-quantity { font-size: 12px; }
.users-page .users-table--companies .table-list thead tr.movil-table th:nth-child(1) { width: 12%; }
.users-page .users-table--companies .table-list thead tr.movil-table th:nth-child(2) { width: 55%; }
.users-page .users-table--companies .table-list thead tr.movil-table th:nth-child(3) { width: 33%; }
.users-page .users-table--companies .table-list tbody tr td:first-child { min-width: 80px; }

@media (max-width: 768px) {
 .users-page .users-resource-actions { display: block; }
 .users-page .users-resource-actions .width-content { width: 100%; padding: 8px 12px !important; flex-wrap: wrap; }
 .users-page .users-assignment-actions { flex-direction: column; align-items: stretch; padding: 16px; gap: 16px; }
 .users-page .users-save-action { width: 100%; }
 .users-page .users-table .table-list .search-input { display: inline-flex; }
 .users-content { padding: 16px 12px; }
 .users-heading { padding: 16px; }
 .users-heading > div:first-child { width: 100%; }
 .users-heading h1 { font-size: 21px; }
 .users-card .v-card__text { padding: 16px; }
 .users-fields { grid-template-columns: 1fr; gap: 12px; }
 .users-page .users-table .table-list .movil-table { display: table-row; }
 .users-page .users-table .table-list .movil-table th, .users-page .users-table .table-list .movil-table td { display: table-cell; }
 .users-page .users-table .table-list .movil-header-row { display: table-cell; }
 .users-page .users-table .table-list .table-pagination { display: table-footer-group; }
}

.users-status-dialog { border-radius: 16px; }
.users-status-card { overflow: hidden; border-radius: 16px; background: #fff; }
.users-status-card .users-status-body { padding: 28px 28px 24px; }
.users-status-symbol { display: inline-flex; align-items: center; justify-content: center; width: 52px; height: 52px; margin-bottom: 18px; border-radius: 14px; background: #fff0ed; }
.users-status-card .users-status-symbol .v-icon { color: #b93829 !important; font-size: 28px; }
.users-status-card h2 { margin: 0 0 10px; color: #243b49; font-size: 22px; font-weight: 600; line-height: 1.3; }
.users-status-card p { margin: 0; color: #586d79; font-size: 14px; line-height: 1.65; }
.users-status-identity { display: flex; align-items: center; gap: 12px; margin-top: 20px; padding: 14px; border: 1px solid #e2e9ee; border-radius: 10px; background: #f8fafc; }
.users-status-avatar { display: flex; align-items: center; justify-content: center; flex: 0 0 38px; height: 38px; border-radius: 50%; background: #e1f0f4; color: #24758b; font-size: 15px; font-weight: 600; }
.users-status-identity > div { min-width: 0; }
.users-status-identity strong, .users-status-identity > div > span { display: block; overflow-wrap: anywhere; }
.users-status-identity strong { color: #2c404a; font-size: 14px; font-weight: 600; }
.users-status-identity > div > span { margin-top: 3px; color: #607582; font-size: 12px; }
.users-status-card .users-status-actions { justify-content: flex-end; gap: 12px; padding: 18px 28px; border-top: 1px solid #e6edf1; background: #fbfcfd; }
.users-status-card .users-status-actions .v-btn { min-height: 42px; height: auto; margin: 0; padding: 10px 16px; border-radius: 8px; text-transform: none; font-size: 13px; font-weight: 600; letter-spacing: 0; }
.users-status-card .users-status-actions .v-btn__content { white-space: normal; }
.users-status-card .users-status-cancel { border: 1px solid #cedbe3; color: #405966 !important; background: #fff !important; }
.users-status-card .users-status-confirm { color: #fff !important; background: #b93829 !important; }
.users-status-card .users-status-confirm:not(.v-btn--disabled):hover { background: #982c20 !important; }
.users-status-card .users-status-cancel:not(.v-btn--disabled):hover { background: #edf3f7 !important; }
.users-status-card .v-btn:focus-visible { outline: 2px solid #006edb; outline-offset: 3px; }
.users-status-card .v-btn--disabled { opacity: 0.65; }
.users-status-card--activate .users-status-symbol { background: #e8f5f6; }
.users-status-card--activate .users-status-symbol .v-icon { color: #00777e !important; }
.users-status-card--activate .users-status-confirm { background: #00777e !important; }
.users-status-card--activate .users-status-confirm:not(.v-btn--disabled):hover { background: #005e64 !important; }
@media (max-width: 480px) {
 .users-status-dialog { margin: 16px; }
 .users-status-card .users-status-body { padding: 24px 20px; }
 .users-status-card .users-status-actions { flex-direction: column-reverse; align-items: stretch; padding: 16px 20px; }
 .users-status-card .users-status-actions .v-btn { width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/pages/users/page-users.vue